import { LocalizableBodyInterface } from '@sport-activities/sdk';

export function buildLocatableBody<T>(
  locale: string,
  value: T
): LocalizableBodyInterface<T> {
  return {
    locale,
    value,
  };
}
